(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["heartz-bundle-experience"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-heartz-bundle]');
    if (!root) return;

    const BUNDLE = 7;
    const PRICES = { 7: 140, 14: 280, 21: 420 };
    const MAX = 21;

    const pageType = root.dataset.pageType;
    if (pageType === 'collection') document.documentElement.classList.add('heartz-bundle-collection');
    const collectionUrl = root.dataset.collectionUrl;
    const cartUrl = root.dataset.cartUrl;
    const rootUrl = root.dataset.rootUrl.replace(/\/?$/, '/');
    const addedText = root.dataset.addedText;
    const sticky = root.querySelector('[data-heartz-sticky]');
    const status = root.querySelector('[data-heartz-status]');
    const detail = root.querySelector('[data-heartz-detail]');
    const meter = root.querySelector('[data-heartz-meter]');
    const cta = root.querySelector('[data-heartz-cta]');
    const toast = root.querySelector('[data-heartz-toast]');
    let toastTimer;

    const isShirt = (item) => {
      const t = (item.product_title || '') + ' ' + (item.product_type || '');
      return /shirt/i.test(t) && !/polo/i.test(t);
    };
    const shirtQuantity = (cart) => cart.items.reduce((total, item) => total + (isShirt(item) ? item.quantity : 0), 0);
    const cartEndpoint = `${rootUrl}cart.js`;
    const addEndpoint = `${rootUrl}cart/add.js`;

    const showToast = (message) => {
      if (!toast) return;
      toast.textContent = message;
      toast.classList.add('is-visible');
      window.clearTimeout(toastTimer);
      toastTimer = window.setTimeout(() => toast.classList.remove('is-visible'), 2600);
    };

    const renderProgress = (quantity) => {
      if (!sticky) return;
      sticky.hidden = false;
      if (quantity === 0) {
        status.textContent = `Kies je ${BUNDLE} T-shirts`;
        detail.textContent = '7 voor €140 · 14 voor €280 · 21 voor €420';
        cta.textContent = 'Begin met kiezen';
        cta.href = collectionUrl;
        meter.style.width = '0%';
        return;
      }
      if (quantity > MAX) {
        status.textContent = `${quantity} T-shirts gekozen`;
        detail.textContent = `Maximaal ${MAX} T-shirts per bestelling`;
        cta.textContent = 'Naar winkelwagen';
        cta.href = cartUrl;
        meter.style.width = '100%';
        return;
      }
      const completed = quantity % BUNDLE === 0;
      if (completed) {
        status.textContent = `${quantity} gekozen · €${PRICES[quantity]}`;
        detail.textContent = `Bundel compleet · + €${(quantity / BUNDLE) * 20} verzending`;
        cta.textContent = 'Naar winkelwagen';
        cta.href = cartUrl;
        meter.style.width = '100%';
        return;
      }
      const nextBundle = Math.ceil(quantity / BUNDLE) * BUNDLE;
      const remaining = nextBundle - quantity;
      const step = quantity % BUNDLE;
      meter.style.width = `${Math.round((step / BUNDLE) * 100)}%`;
      status.textContent = `${quantity} gekozen · nog ${remaining} erbij`;
      detail.textContent = `${nextBundle} T-shirts voor €${PRICES[nextBundle]}`;
      cta.textContent = pageType === 'collection' ? 'Verder kiezen' : 'Shirts toevoegen';
      cta.href = collectionUrl;
    };

    const refreshCart = async () => {
      const response = await fetch(`${cartEndpoint}?_=${Date.now()}`, { cache: 'no-store', headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Cart unavailable');
      const cart = await response.json();
      renderProgress(shirtQuantity(cart));
      document.querySelectorAll('.thb-item-count').forEach((badge) => {
        badge.textContent = cart.item_count;
        badge.style.display = cart.item_count > 0 ? '' : 'none';
      });
      return cart;
    };

    const enhancePhotoPreviews = (() => {
      if (pageType !== 'collection') return () => {};
      const mobile = window.matchMedia('(max-width: 749px), (hover: none) and (pointer: coarse)');
      const records = new Map();
      const paint = (record) => { record.card.classList.toggle('heartz-photo-active', mobile.matches && record.ready && record.wanted); };
      const loadPhoto = (record) => {
        const image = record.image;
        if (image.dataset.srcset && !image.srcset) image.srcset = image.dataset.srcset;
        if (image.dataset.src && !image.getAttribute('src')) image.src = image.dataset.src;
        if (!record.loading) { record.loading = true; image.sizes = `${Math.ceil(record.link.getBoundingClientRect().width)}px`; image.loading = 'eager'; }
        if (image.complete && image.naturalWidth > 40) { record.ready = true; paint(record); }
      };
      const reset = (record) => { record.touching = false; record.wanted = false; paint(record); };
      const preloadObserver = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const record = records.get(entry.target.closest('product-card'));
          if (entry.isIntersecting && record && mobile.matches) loadPhoto(record);
        });
      }, { rootMargin: '300px 0px' }) : null;
      mobile.addEventListener('change', () => { records.forEach((record) => { reset(record); record.card.classList.toggle('heartz-photo-mobile', mobile.matches); }); });
      window.addEventListener('blur', () => records.forEach(reset));
      return () => {
        records.forEach((record, card) => { if (card.isConnected) return; reset(record); preloadObserver?.unobserve(record.link); records.delete(card); });
        document.querySelectorAll('#product-grid product-card').forEach((card) => {
          if (records.has(card)) return;
          const link = card.querySelector('.product-featured-image-link');
          const image = link?.querySelector('.product-secondary-image');
          if (!link || !image) return;
          const record = { card, link, image, ready: false, wanted: false, touching: false, loading: false };
          records.set(card, record);
          card.classList.add('heartz-photo-managed');
          card.classList.toggle('heartz-photo-mobile', mobile.matches);
          image.addEventListener('load', () => loadPhoto(record));
          image.addEventListener('error', () => { record.ready = false; reset(record); });
          link.addEventListener('pointerdown', (event) => {
            if (event.pointerType === 'mouse' || event.isPrimary === false || !mobile.matches) return;
            record.touching = true; record.wanted = true; loadPhoto(record); paint(record);
          }, { passive: true });
          link.addEventListener('pointermove', (event) => {
            if (!record.touching || event.isPrimary === false) return;
            const bounds = link.getBoundingClientRect();
            record.wanted = event.clientX >= bounds.left && event.clientX <= bounds.right && event.clientY >= bounds.top && event.clientY <= bounds.bottom;
            paint(record);
          }, { passive: true });
          ['pointerup', 'pointercancel', 'lostpointercapture'].forEach((name) => { link.addEventListener(name, () => reset(record), { passive: true }); });
          preloadObserver?.observe(link);
        });
      };
    })();

    const enhanceCards = () => {
      if (pageType !== 'collection') return;
      document.querySelectorAll('product-card').forEach((card) => {
        card.querySelectorAll('.swatch-wrap a').forEach((link) => {
          const option = link.querySelector('.individual-option');
          if (!option) return;
          if (option.classList.contains('out-of-stock-option')) {
            link.setAttribute('aria-disabled', 'true');
            link.setAttribute('tabindex', '-1');
          } else {
            const productTitle = card.querySelector('.product-card-title')?.textContent?.trim() || 'T-shirt';
            const size = option.childNodes[0]?.textContent?.trim() || option.textContent.trim();
            link.setAttribute('aria-label', `Voeg ${productTitle}, maat ${size}, toe aan winkelwagen`);
            link.dataset.heartzQuickAdd = 'true';
          }
        });
      });
    };

    const addProductMarker = () => {
      if (root.dataset.productEligible !== 'true') return;
      document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
        if (form.querySelector('[name="properties[_24heartz_bundle]"]')) return;
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[_24heartz_bundle]';
        input.value = '7-shirts-140';
        form.appendChild(input);
      });
    };

    document.addEventListener('click', async (event) => {
      const link = event.target.closest('[data-heartz-quick-add="true"]');
      if (!link || pageType !== 'collection') return;
      const option = link.querySelector('.individual-option');
      if (!option || option.classList.contains('out-of-stock-option')) return;
      const variantId = new URL(link.href, window.location.origin).searchParams.get('variant');
      if (!variantId) return;
      event.preventDefault();
      if (link.classList.contains('heartz-is-adding')) return;
      link.classList.add('heartz-is-adding');
      try {
        const response = await fetch(addEndpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1, properties: { _24heartz_bundle: '7-shirts-140' } }] })
        });
        if (!response.ok) throw new Error('Add failed');
        showToast(addedText);
        await refreshCart();
        document.dispatchEvent(new CustomEvent('cart:item-added'));
      } catch (error) {
        showToast('Deze maat kon niet worden toegevoegd. Probeer opnieuw.');
      } finally {
        link.classList.remove('heartz-is-adding');
      }
    });

    document.addEventListener('cart:item-added', () => window.setTimeout(refreshCart, 180));
    document.addEventListener('line-item:change:end', () => window.setTimeout(refreshCart, 180));

    const observer = new MutationObserver(() => { enhanceCards(); enhancePhotoPreviews(); addProductMarker(); });
    observer.observe(document.body, { childList: true, subtree: true });

    enhanceCards();
    enhancePhotoPreviews();
    addProductMarker();
    refreshCart().catch(() => {});
  })();

  } catch(e) { console.error(e); }
})();
})();
